module.exports = __webpack_public_path__ + "static/img/rank_141.d0fc5f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_141.png
// module id = YM65
// module chunks = 0